import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import colorStyle from '@/components/mapv2/colorstyle';
import 'ol/ol.css';
import { Map, View } from 'ol';
import VectorLayer from 'ol/layer/Vector';
import LayerImage from 'ol/layer/Image';
import { transformExtent, fromLonLat, transform, toLonLat } from 'ol/proj';
import Projection from 'ol/proj/Projection';
import SourceImagestatic from 'ol/source/ImageStatic';
import { defaults } from 'ol/control';
export default {
  name: 'maptest',
  components: {
    colorStyle
  },
  meta: {
    title: ''
  },
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  watch: {},
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      // const imageExtent = transformExtent([117.315378, 36.689652, 117.961808, 37.146782], 'EPSG:4326', 'EPSG:3857')
      // const imageProjection = new Projection({
      //   code: 'xkcd-image',
      //   units: 'pixels',
      //   extent: imageExtent
      // });
      // const staticImageLayer = new LayerImage({
      //   source: new SourceImagestatic({
      //     url: 'http://museum.chaoxing.com/star3/origin/c86952fd1535d2330d641438347c57c8.png',
      //     projection: imageProjection,
      //     imageExtent: imageExtent,
      //   })
      // })
      //  this.map = new Map({
      //   controls: defaults({
      //     attribution: false,
      //   }),
      //   layers: [staticImageLayer],
      //   target: this.$refs[`map0`],
      //   view: new View({
      //     center: transform([117.736807, 36.87803], 'EPSG:4326', 'EPSG:3857'),
      //     zoom: 11,
      //     minZoom: 10,
      //     maxZoom: 12
      //   })
      // })

      let extent = [0, 0, 480, 480];
      let projection = new Projection({
        projection: 'EPSG:4326',
        code: 'xkcd-image',
        units: 'pixels',
        extent: extent
      });
      const staticImageLayer = new LayerImage({
        source: new SourceImagestatic({
          url: 'https://p.ananas.chaoxing.com/star3/origin/bab40f6cca4522ff726de8d90901cdcd.png',
          //这里添加静态图片的地址
          projection: projection,
          imageExtent: extent
        })
      });
      this.map = new Map({
        controls: defaults({
          attribution: false
        }),
        layers: [staticImageLayer],
        target: this.$refs[`map0`],
        view: new View({
          projection: projection,
          center: [120, 120],
          zoom: 2,
          minZoom: 1,
          maxZoom: 3
        })
      });
    }
  }
};